import { LgpResultsQuery } from '../types';
import { IDriverStandings, ITopDriversRow } from '@sky-it-livedata/livedata-sports-design-system';
import { RaceSessionStatus, RaceSessionType } from '../../../types/lgp';
import { intcmpMap } from '../../../utils/intcmp';
import { ErrorName, WidgetError } from '../../../utils/errors';
import { isValidLgpResults } from './typeguards';
import { CreateLgpResultsWidgetInputSchema, LgpInfoLink, LgpResultsSession } from 'appsync';
import { getRankingVariant } from './utils';

export default (obj: LgpResultsQuery): IDriverStandings => {
  if (isValidLgpResults(obj)) {
      CreateLgpResultsWidgetInputSchema().parse(obj.data.getLgpResultsWidget, {reportInput: true});
      const { sessions, gpInfo, gpStatus, sessionName, results, ranking, calendar } = obj.data.getLgpResultsWidget;

      const standingsList = sessions?.map<IDriverStandings['standingsList'][0]>((sessionObj) => {
        const session = sessionObj as LgpResultsSession;

        return {
          rows: (session.sessionInfo?.details ?? []).map((row) => ({
            driverName: (() => {
              const surname = row?.customDriverSurname ?? '';
              const formattedSurname = surname ? `${surname[0]}${surname.slice(1).toLowerCase()}` : '';
              const givenInitial = (row?.customDriverName ?? '')[0] ?? '';
              return `${formattedSurname}${givenInitial ? ' ' + givenInitial + '.' : ''}`.trim();
            })(),
            driverUrl: row?.customDriverPageUrl,
            fastestLap: row?.fastestLap,
            gap: row?.gap,
            isFastestLap: row?.isFastestLap,
            logoUrl: row?.flagUrl,
            position: row?.position,
            timing: row?.timing,
            teamName: row?.customTeamName,
            teamUrl: row?.customTeamPageUrl,
          })) as ITopDriversRow[],
          status: session.sessionInfo?.sessionStatus as RaceSessionStatus,
          startDateTime: session.sessionInfo?.startDateTime as string,
          rankingVariant: getRankingVariant(session.sessionInfo?.sessionLabel as RaceSessionType),
          tableTitle: session.sessionInfo?.sessionLabel || "" ,
          trackingData: { dataAttribute: 'intcmp', driverLink: intcmpMap.driverLink },
        };
      }) ?? [];

      const links: LgpInfoLink[] = [calendar, results, ranking].filter((link): link is LgpInfoLink => !!link);

      const transformedLinks: { text: string; link: string }[] = links
        .map((l) => ({ text: l.text ?? '', link: l.link ?? '' }))
        .filter((l) => l.text !== '' && l.link !== '');

      return {
        status: gpStatus as RaceSessionStatus,
        grandPrixTitle: gpInfo!.customGpName as string,
        standingsList,
        hasSEOTitle: true,
        rankingVariant: getRankingVariant(sessionName as RaceSessionType),
        hasLgpAnalytics: true,
        links: transformedLinks,
        sessionName: sessionName as RaceSessionType,
      };
  } else {
    throw new WidgetError<ErrorName>({
      name: 'NO_VALID_DATA',
      message: 'Invalid transformer input, Error in LgpResultsQuery object',
      data: obj
    });
  }
};
